import { render, staticRenderFns } from "./ListaEspera.vue?vue&type=template&id=4c05d56b&scoped=true"
import script from "./ListaEspera.vue?vue&type=script&lang=js"
export * from "./ListaEspera.vue?vue&type=script&lang=js"
import style0 from "./ListaEspera.vue?vue&type=style&index=0&id=4c05d56b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05d56b",
  null
  
)

export default component.exports